import { useEffect, useState } from "react";

interface BrailleSpinnerProps {
  size?: number;
  gap?: number;
  color?: string;
  label?: string;
  className?: string;
}

const BRAILLE_FRAMES = ["⠋", "⠙", "⠹", "⠸", "⠼", "⠴", "⠦", "⠧", "⠇", "⠏"];

export function BrailleSpinner({
  size = 12,
  color = "var(--fintheon-primary, var(--fintheon-accent))",
  label,
  className,
}: BrailleSpinnerProps) {
  const [frame, setFrame] = useState(0);

  useEffect(() => {
    const reduced =
      typeof window !== "undefined" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) return;
    const id = window.setInterval(
      () => setFrame((value) => (value + 1) % BRAILLE_FRAMES.length),
      100,
    );
    return () => window.clearInterval(id);
  }, []);

  return (
    <span
      role="status"
      aria-label={label ?? "Loading"}
      className={`braille-spinner inline-flex items-center justify-center font-mono leading-none${className ? ` ${className}` : ""}`}
      style={{
        width: size,
        height: size,
        color,
        fontSize: size,
      }}
    >
      {BRAILLE_FRAMES[frame]}
    </span>
  );
}

export function BrailleSpinnerCentered({
  size = 12,
  color,
  label,
}: BrailleSpinnerProps) {
  return (
    <div className="flex items-center justify-center py-3">
      <BrailleSpinner size={size} color={color} label={label} />
    </div>
  );
}
